<template>
     <div id='menu' class='menu-popup hidden' >
        <div class='menu-popup-container' v-if='selected_heading.sub_headings'>
            <div class='sub-categories-container'>
                <div v-for='sub_heading in selected_heading.sub_headings' :key='sub_heading.id' class='column'>
                    <a class='sub-heading' :href="(sub_heading.type == 'CU') ? sub_heading.custom_url : `/${sub_heading.sef_url}`" @click='selectedMenuItem($event,sub_heading)'>{{sub_heading.name}}</a>
                    <div v-for='menu_item in sub_heading.menu_items' :key='menu_item.id'>
                        <a class='menu-item' :href="(menu_item.type == 'CU') ? menu_item.custom_url : `/${menu_item.sef_url}`" @click='selectedMenuItem($event,menu_item)'>{{menu_item.name}}</a>
                    </div>
                </div>
            </div>
            <!-- <div class='promo-section'>
                <MenuPromoImages/>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    props: ['selected_heading'],
    emits: ['selectedMenuItemListener', 'cancelHideListener', 'hideMenuListener'],
    methods:{
        selectedMenuItem(event, category){
            this.$emit('selectedMenuItemListener', event, category);
        },
        cancelHide() {
            this.$emit('cancelHideListener');
        },
        hideMenu() {
            this.$emit('hideMenuListener');
        }
    }
}
</script>

<style lang="scss" scoped>

.menu-popup{
    position: absolute;
    width: 100%;
    // width: 70%;
    margin-top: 40px;
    top: 0;
    border-radius: 12px;
    background-color: white;
    background-color: rgba( 256, 266, 256, 1);
    // backdrop-filter: blur(50px);
    padding: 30px 40px;
    overflow-y:auto; 
    overflow-x:hidden; 
    scrollbar-width: thin; //Firefox only
    scrollbar-color: darkgrey white; //Firefox only
    box-shadow: 0px 30px 40px -20px hsl(0, 0%, 53%);
    
}
.menu-popup-container{
    display: flex;
}
.sub-categories-container{
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    // flex-wrap: wrap;
    gap: 24px 0px;
    align-items: flex-start;
    // flex: 2;
    // padding-left: 150px;
}
.promo-section{
    flex: 1;
    padding-right: 150px;
}
.column{
    flex-basis: 17%;
    display: flex;
    flex-direction: column;
    gap: 15px;
    // border-right: solid #e9ecef 1px;
    padding-left: 20px;
}
.sub-heading{
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 5px;
    cursor: pointer;
    // text-transform: uppercase;
    // font-size: 1rem;
    text-decoration: none;
    color: var(--primary-colour-2);

    &:hover{
        text-decoration: underline;
    }
}

.menu-item{
    font-size: 0.85rem;
    cursor: pointer;
    color: #495057;
    text-decoration: none;
}

.menu-popup::-webkit-scrollbar { //Chrome, Edge, and Safari 
  width: 0.5rem;
}
 
.menu-popup::-webkit-scrollbar-track{ //Chrome, Edge, and Safari 
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
}
 
.menu-popup::-webkit-scrollbar-thumb { //Chrome, Edge, and Safari 
  background-color: darkgrey;
  border-radius: 10px;
}

.menu-popup.hidden{
    display:none;
}

</style>